import { render, staticRenderFns } from "./VhostPHPConfigDialog.vue?vue&type=template&id=46ca5554&"
import script from "./VhostPHPConfigDialog.vue?vue&type=script&lang=ts&"
export * from "./VhostPHPConfigDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports